import React from 'react';
import { Users, LayoutDashboard, Sparkles } from 'lucide-react';
export function TrustStrip() {
  const items = [{
    icon: <Users className="w-4 h-4 text-primary" data-id="element-521" />,
    text: 'Built for artists, venues, and booking teams'
  }, {
    icon: <LayoutDashboard className="w-4 h-4 text-primary" data-id="element-522" />,
    text: 'Discovery, deals, contracts, payments, and tour ops in one place'
  }, {
    icon: <Sparkles className="w-4 h-4 text-primary" data-id="element-523" />,
    text: 'AI-assisted, human-controlled workflows'
  }];
  return <section className="border-y border-border bg-surface/30 py-6 relative overflow-hidden" data-id="element-524">
      {/* Gradient Masks for smooth fade on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" data-id="element-525"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" data-id="element-526"></div>

      <div className="flex overflow-hidden" data-id="element-527">
        <div className="flex animate-marquee whitespace-nowrap items-center" data-id="element-528">
          {/* First set of items */}
          {items.map((item, index) => <div key={`set1-${index}`} className="flex items-center gap-3 text-sm text-textMuted mx-12" data-id="element-529">
              {item.icon}
              <span data-id="element-530">{item.text}</span>
              <div className="w-1.5 h-1.5 rounded-full bg-border ml-12" data-id="element-531"></div>
            </div>)}
          {/* Duplicate set for seamless infinite loop */}
          {items.map((item, index) => <div key={`set2-${index}`} className="flex items-center gap-3 text-sm text-textMuted mx-12" data-id="element-532">
              {item.icon}
              <span data-id="element-533">{item.text}</span>
              <div className="w-1.5 h-1.5 rounded-full bg-border ml-12" data-id="element-534"></div>
            </div>)}
        </div>
      </div>
    </section>;
}